import React from "react";
import styles from "./StoryDeleted.module.scss";

const StoryDeleted = () => {
  return (
    <div className={styles.storyDeleted}>
      <div className={styles.content}>
        <img src="./img/deleted-story.png" alt="Story Deleted" className={styles.image} />
        <p>
          Uh-oh. We can't load this Story right now. It may have been archived or deleted. If you haven't received it by
          6pm the day after your booking, email{" "}
          <a href="mailto:stories@flightclubdarts.com">stories@flightclubdarts.com</a> with your booking number and
          we'll try to find it.
        </p>
      </div>
    </div>
  );
};

export default StoryDeleted;
